import { ResourceLanguage } from 'i18next';
import { TranslationExtensionInterface } from '../../../../extension/interface/translation.extension.interface';

/**
 * Copy shared only between MOBILITY and AT_MOBILITY (ticket-receipt flows) - same idea as
 * LunchReceiptTranslationExtension, split out because it doesn't apply to the other 3 benefits.
 * Resolved via mobilityTicketBenefitKeys in ../receiptTranslation.ts, moduleName `mobilityTicket`.
 */
export class MobilityTicketTranslationExtension extends TranslationExtensionInterface {
  moduleName = 'mobilityTicket';

  get translations(): ResourceLanguage {
    return {
      infoPage: {
        refundable: {
          title: 'Erstattungsfähige Tickets:',
          not: {
            title: 'Nicht erstattungsfähige Tickets:',
          },
        },
      },
      field: {
        total: 'Betrag',
      },
      placeholder: {
        comment: 'Hier Kommentar eingeben',
      },
      addReceiptFlow: {
        hintTotal: 'Gib den kompletten Betrag des Tickets ein',
        receiptConditions: 'Die von mir getroffenen Angaben sind korrekt und ich habe das Ticket selbst genutzt',
        submitReceipt: 'Ticket einreichen',
      },
      receiptImageChecklist:
        'Bitte achte darauf, dass der Beleg gut lesbar ist und folgendes enthält:<0>Name des Anbieters</0><0>Datum</0><0>Gesamtbetrag</0>Unscharfe oder fehlerhafte Belege müssen wir leider ablehnen.',
      partialRefund: {
        reachedMaxPerMonth: 'Der maximale Erstattungswert von {{monthlyLimit, euro}} wurde bereits erreicht.',
      },
    };
  }
}
